import { useNavigate } from 'react-router'
import { cn } from '#app/utils/misc.tsx'
import { CardImage } from './ui/card-image.tsx'
import { Tag } from './ui/tag.tsx'

interface ProjectsSectionProps {
	className?: string
}

export function ProjectsSection({ className }: ProjectsSectionProps) {
	const navigate = useNavigate()
	return (
		<section className={cn('bg-white py-4 md:py-16', className)}>
			<div className="container mx-auto px-6">
				<div className="flex flex-col items-center gap-16">
					{/* Secondary Content */}
					<div className="flex max-w-[300px] flex-col items-center gap-8 md:max-w-[749px]">
						{/* Tag/Chip */}
						<Tag
							size="l"
							corner="rounded"
							variant="secondary"
							color="blue"
							appearance="solid"
							leftIcon="rocket-01"
							option="text-icon-left"
						>
							Proyectos
						</Tag>

						{/* Main Heading */}
						<h2 className="font-parkinsans max-w-[231px] text-center text-2xl leading-8 font-medium text-blue-800 md:max-w-none md:text-[48px] md:leading-[64px]">
							Sostenibilidad es{' '}
							<span className="md:text-green-500">acción diaria</span>
						</h2>

						{/* Description */}
						<p className="font-inter text-center text-base leading-[26px] font-normal text-neutral-600 md:max-w-[623px] md:text-lg md:leading-9">
							Creamos una red de personas y organizaciones que comparten su
							visión de un mundo más inclusivo y sostenible.
						</p>
					</div>

					{/* Cards */}
					<div className="flex w-full max-w-[300px] flex-col items-center justify-center gap-6 md:max-w-[1200px] md:flex-row md:gap-3">
						{/* Educa ConCiencia Card */}
						<CardImage
							backgroundImage="/img/programa-madre-card.avif"
							title="Educa ConCiencia"
							iconButtonIcon="arrow-up-right-01-round"
							onIconButtonClick={() => navigate('/programa-madre')}
							showButton={false}
							className="h-[365px] w-full md:w-[594px]"
						/>

						{/* Fondo de Agua Card */}
						<CardImage
							backgroundImage="/img/fondo-agua-card.avif"
							title="Fondo de Agua del Río Mendoza"
							iconButtonIcon="arrow-up-right-01-round"
							onIconButtonClick={() => console.log('Fondo de Agua clicked')}
							showButton={false}
							className="h-[365px] w-full md:w-[594px]"
						/>
					</div>
				</div>
			</div>
		</section>
	)
}

export default ProjectsSection
